import React, { useContext } from 'react';
import UserProvider from '../../context/UserContext';
import copy from "copy-to-clipboard";
import { useAlert } from "react-alert";
import '../../dash.css'

const CardLincense = () => {
    const alert = useAlert();
    const Data = useContext(UserProvider.context);
    const memberData = Data.member;
    
    let license;
    if(memberData.key){
        let license_list =  memberData.key.split("-")
        license = `XXXXX-${license_list[license_list.length-2]}-${license_list[license_list.length-1]}`
    }
    else{
        license =  "Key not found"
    }
    

    let system;
    if(memberData.system_name === null){
        system = "Not set yet";
    }
    else{
        system = memberData.system_name;
    }

    function alertSuccess(message){
        if (document.getElementById('__react-alert__').children.length === 0) {
            alert.success(message)
        }
    }

    function copyClipboard(){
        copy(memberData.key)
        alertSuccess("Key copied")
    }

    function ShowRefreshCard(){
        var x = document.getElementById("refresh");
        if (x.style.display === "flex") {
            x.style.display = "none";
        } else {
            x.style.display = "flex";
        }

        var y = document.getElementById("overlay");
        if (y.style.display === "flex") {
            y.style.display = "none";
        } else {
            y.style.display = "flex";
        }
    }

    return(
        <div className="card-component">
            <div className="card-content card-content-holder">
                <div>
                    <h4 className="card-title">License</h4>
                    <div>
                        <button id="copy-clipboard" className="card-button" onClick={copyClipboard}>
                            <h5><i className="far fa-copy"></i>{license}</h5>
                        </button>
                    </div>
                    <div>
                        <button id="refresh-key" className="card-button" onClick={ShowRefreshCard}>
                            <h5><i className="fas fa-sync-alt"></i>Refresh key (To unbind computer)</h5>
                        </button>
                    </div>
                    <div className="system-name">
                        <h5><b className="bold">System: </b>{system}</h5>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default CardLincense;